import { useState, lazy, Suspense, useEffect } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import StatsBar from "@/components/StatsBar";
import AnimationToggle from "@/components/AnimationToggle";
import { useLanguage } from "@/contexts/LanguageContext";

// Lazy load non-critical sections to reduce initial bundle size
const ProblemGapSection = lazy(() => import("@/components/ProblemGapSection"));
const CustomerPlatformSection = lazy(() => import("@/components/CustomerPlatformSection"));
const ServicesSection = lazy(() => import("@/components/ServicesSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const ProcessSection = lazy(() => import("@/components/ProcessSection"));
const VolumePricingSection = lazy(() => import("@/components/VolumePricingSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  const [isAnimationPlaying, setIsAnimationPlaying] = useState(true);
  const { language, setLanguage, content: currentContent } = useLanguage();

  useEffect(() => {
    // GA helper is defined globally in index.html; avoid duplicate injection
  }, []);

  return (
    <div className={`min-h-screen animated-bg ${!isAnimationPlaying ? 'paused' : ''}`}>
      <Header 
        language={language} 
        onLanguageChange={setLanguage}
        content={currentContent.header}
      />
      
      <main>
        <HeroSection content={currentContent.hero} />
        <StatsBar content={currentContent.stats} />
        <Suspense fallback={<div className="h-8" />}>
          <ProblemGapSection />
          <CustomerPlatformSection />
          <ServicesSection content={currentContent.services} />
          <ProcessSection content={currentContent.process} />
          <FAQSection content={currentContent.faq} />
          <VolumePricingSection content={currentContent.volumePricing} />
          <ContactSection content={currentContent.contact} />
        </Suspense>
      </main>
      
      <Suspense fallback={<div className="h-16" />}>
        <Footer 
          content={{
            company: "Volym Digitalbyrå AB",
            rights: language === "sv" ? "Alla rättigheter förbehållna." : "All rights reserved."
          }}
        />
      </Suspense>
      
      <AnimationToggle onToggle={setIsAnimationPlaying} />
    </div>
  );
};

export default Index;
